import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormCapsule: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormCapsule"><Path d="M14.5 4C18.9183 4 22.5 7.58172 22.5 12C22.5 16.4183 18.9183 20 14.5 20H9.5C5.08172 20 1.5 16.4183 1.5 12C1.5 7.58172 5.08172 4 9.5 4H14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormCapsule;
